import '../index.css';
var styles = {
  "textAreaContainer": "bp_text_area_module_textAreaContainer--cce13",
  "label": "bp_text_area_module_label--cce13",
  "hidden": "bp_text_area_module_hidden--cce13",
  "disabled": "bp_text_area_module_disabled--cce13",
  "inlineError": "bp_text_area_module_inlineError--cce13"
};
export { styles as default };